<template>
  <div class="relative border-b border-gray-200 dark:border-gray-800 overflow-hidden">
    <!-- Light theme background -->
    <div
      class="absolute inset-0 bg-no-repeat bg-cover bg-center opacity-100 dark:opacity-0 transition-opacity duration-300"
      style="
        background-image: url(&quot;/background/jbc-bg-light-stripe.webp&quot;);
        background-position-y: 0%;
      "
    ></div>

    <!-- Dark theme background -->
    <div
      class="absolute inset-0 bg-no-repeat bg-cover bg-center opacity-0 dark:opacity-100 transition-opacity duration-300"
      style="
        background-image: url(&quot;/background/jb-bg-dark-stripe.webp&quot;);
        background-position-y: 100%;
      "
    ></div>

    <!-- Content overlay -->
    <div class="relative">
      <div class="container mx-auto px-4 py-8 md:py-12">
        <div class="mx-auto">
          <h1 class="event-name text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            {{ event.name }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  event: {
    type: Object,
    required: true
  }
});
</script>

<style scoped>
@media (max-width: 440px) {
  .event-name {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
</style>
